const fields = {
  analysis_type: 'Analysis method',
  adjustment_covariates: 'Adjustment covariates',
  adjustment_status: 'Adjustment status',
  sample_n: 'Analysis sample',
  contrast: 'Comparison groups',
  reference_group: 'Reference group',
  source_timepoint: 'Source timing',
  target_timepoint: 'Target timing',
  stat_type: 'Statistical measure',
  stat_unit: 'Units',
  significance_basis: 'Significance definition',
};
const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
const known = value => value != null && normalize(value) !== '' && !['not_reported', 'not reported', 'unknown', 'unspecified'].includes(normalize(value).toLowerCase()) && (!Array.isArray(value) || value.length > 0);

export function supportingEvidence(record) {
  const primary = normalize(record.evidence);
  const selected = new Map();
  const passages = record.supporting_passages || [];
  for (const [field, label] of Object.entries(fields)) {
    if (!known(record[field])) continue;
    const id = record.field_evidence_ids?.[field];
    const proof = record.field_evidence?.[field] || passages.find(p => id && p.evidence_id === id);
    const text = normalize(proof?.evidence);
    if (!text || text === primary) continue;
    if (selected.has(text)) selected.get(text).labels.push(label);
    else selected.set(text, { proof, labels: [label] });
  }
  return [...selected.values()].map(({ proof, labels }) => ({ ...proof, label: labels.join(' · ') }));
}

export function readableEvidence(value) {
  // Repair PDF layout only; retain original wording, numbers and punctuation.
  return String(value || '').replace(/(\p{L})[ \t]*[-\u00ad][ \t]*\r?\n[ \t]*(\p{Ll})/gu, '$1$2')
    .split(/\n\s*\n/).map(paragraph => paragraph.replace(/\s*\n\s*/g, ' ').replace(/[ \t]+/g, ' ').trim()).join('\n\n');
}
